import api from "./api";

export async function listTenants(token: string) {
  const res = await api.get('/admin/tenants', { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any[];
}

export async function updateTenantStatus(token: string, id: string, isActive: boolean) {
  const res = await api.patch(`/admin/tenants/${id}/status`, { isActive }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function deleteTenant(token: string, id: string) {
  const res = await api.delete(`/admin/tenants/${id}`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function listPlans(token: string) {
  const res = await api.get('/admin/plans', { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any[];
}

export async function createPlan(token: string, payload: any) {
  const res = await api.post('/admin/plans', payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function listSubscriptions(token: string) {
  const res = await api.get('/admin/subscriptions', { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any[];
}

export async function setSubscription(token: string, tenantId: string, payload: any) {
  const res = await api.put(`/admin/subscriptions/${tenantId}`, payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

// Subscription Billing APIs
export async function listSubscriptionBills(token: string, tenantId?: string) {
  const url = tenantId ? `/admin/subscription-billing?tenantId=${tenantId}` : `/admin/subscription-billing`;
  const res = await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any[];
}

export async function createSubscriptionInvoice(token: string, tenantId: string, payload?: any) {
  const res = await api.post(`/admin/subscription-billing/${tenantId}/invoices`, payload || {}, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function paySubscriptionInvoice(token: string, billId: string, payload: { amount: number; method: string }) {
  const res = await api.post(`/admin/subscription-billing/${billId}/payments`, payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function sendSubscriptionBill(token: string, billId: string, opts?: { channel?: 'email'|'whatsapp'|'both' }) {
  const q = opts?.channel ? `?channel=${opts.channel}` : '';
  const res = await api.post(`/admin/subscription-billing/${billId}/send${q}`, {}, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}

export async function getSubscriptionInvoicePreview(token: string, billId: string, opts?: { print?: boolean }) {
  const q = opts?.print ? '?print=1' : '';
  const res = await api.get(`/admin/subscription-billing/${billId}/preview${q}`,
    { headers: { Authorization: `Bearer ${token}` }, responseType: 'text' });
  return res.data as string;
}

export async function notifyTenant(token: string, payload: { tenantId: string; subject: string; message: string; channel?: 'email'|'whatsapp'|'both' }) {
  const res = await api.post('/admin/notify', payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as any;
}
